import { TicketKey } from 'flow/types/EntityKeys';
import MenuItemTicketStatus from './MenuItemTicketStatus';
import MenuItemAssignToMe from './MenuItemAssignToMe';
import MenuItemAssignMenu from './MenuItemAssignMenu';
import MenuItemForwardToQueueMenu from './MenuItemForwardToQueueMenu';
import MenuItemCallContact from './MenuItemCallContact';
import MenuItemContactAction from './MenuItemContactAction';
import MenuItemPickQueueItem from './MenuItemPickQueueItem';
import MenuItemNeedsAttention from './MenuItemNeedsAttention';

type Props = {
    ticketKey: TicketKey;
};

const TicketContextMenuItems = ({ ticketKey }: Props) => (
    <>
        <MenuItemTicketStatus ticketKey={ticketKey} />
        <MenuItemAssignToMe ticketKey={ticketKey} />
        <MenuItemAssignMenu ticketKey={ticketKey} />
        <MenuItemForwardToQueueMenu ticketKey={ticketKey} />
        <MenuItemCallContact ticketKey={ticketKey} />
        <MenuItemContactAction ticketKey={ticketKey} />
        <MenuItemPickQueueItem ticketKey={ticketKey} />
        <MenuItemNeedsAttention ticketKey={ticketKey} />
    </>
);

export default TicketContextMenuItems;
